/* ==========================================================
   GLIA EVENTS
   ========================================================== */

document.addEventListener("DOMContentLoaded", () => {

  const openArrow =
    "https://cdn.shopify.com/s/files/1/0284/2450/3395/files/Glia_Open_Arrow.svg?v=1785294786";

  const closeArrow =
    "https://cdn.shopify.com/s/files/1/0284/2450/3395/files/Glia_Close_Arrow.svg?v=1785294786";

  document.querySelectorAll(".glia-event-card__toggle").forEach(button => {

    button.addEventListener("click", () => {

      const card = button.closest(".glia-event-card");

      card.classList.toggle("is-open");

      const open = card.classList.contains("is-open");

      button.setAttribute("aria-expanded", open);

      const label = button.querySelector(".glia-event-card__more");

      const arrow = button.querySelector(".glia-event-card__chevron");

      if (label) {

        label.childNodes[0].textContent =
          open ? "Event Details " : "Event Details ";

      }

      if (arrow) {

        arrow.src = open ? closeArrow : openArrow;

      }

    });

  });

});